import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import { Container, Card, Row, Col } from 'react-bootstrap'; // Import Bootstrap components
import iconUs from './../../images/icons/organisation.png'
import iconWho from './../../images/icons/about.png'
import iconAchGadol from './../../images/icons/ami.png'
import line from './../../images/icons/line.png'
function ThreeCards() {
  return (
    <Container className="d-flex justify-content-center align-items-center" style={{marginTop: '7rem', marginBottom: '7rem'}}>
      <Row>
        <Col lg={4} style={{marginTop:'2rem'}}>
          <Card className='shadow h-100 mb-3' style={{borderRadius: '20px', borderColor: '#f0f0f0'}}>
          <Card.Body className="d-flex flex-column align-items-center justify-content-center">
            <img src={iconUs} alt="Icon 1" width="90" height="90" style={{marginBottom: '40px', marginTop: '40px'}} /> {/**#610A74 */}
              <Card.Title style={{marginBottom: '10px', fontSize: '24px', fontWeight:'700'}}>Qui sommes-nous ?</Card.Title>
              <img src={line} alt="Icon 1" width="30" height="50" style={{marginBottom: '20px'}} /> {/**#610A74 */}

              <Card.Text style={{fontSize: '16px', fontWeight: '600', color: '#4c4f4e', marginRight: '4rem', marginLeft: '4rem', textAlign: 'center', marginBottom: '50px'}}>
              Tsahal Connection est un projet créé en 2015 par d'anciens soldats francophones de l'armée israélienne. Notre objectif est de faciliter l'intégration des francophones dans Tsahal et cela depuis le premier rendez-vous.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} style={{marginTop:'2rem'}}>
        <Card className='shadow h-100 mb-3' style={{borderRadius: '20px',  borderColor: '#f0f0f0'}}>
          <Card.Body className="d-flex flex-column align-items-center justify-content-center">
            <img src={iconWho} alt="Icon 1" width="90" height="90" style={{marginBottom: '40px', marginTop: '40px'}} /> {/**#610A74 */}
            <Card.Title style={{marginBottom: '10px', fontSize: '24px', fontWeight:'700'}}>Pour qui ?</Card.Title>
            <img src={line} alt="Icon 1" width="30" height="50" style={{marginBottom: '20px'}} /> {/**#610A74 */}              
            <Card.Text style={{fontSize: '16px', fontWeight: '600', color: '#4c4f4e', marginRight: '4rem', marginLeft: '4rem', textAlign: 'center', marginBottom: '50px'}}>
                Tsahal Connection est la référence pour les francophones devant ou souhaitant joindre les rangs de Tsahal, peu importe leurs statuts. Nous aidons tout francophone nécessitant une préparation et un soutien avant de joindre Tsahal.              
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} style={{marginTop:'2rem'}}>
        <Card className='shadow h-100' style={{borderRadius: '20px',  borderColor: '#f0f0f0'}}>
          <Card.Body className="d-flex flex-column align-items-center justify-content-center">
            <img src={iconAchGadol} alt="Icon 1" width="90" height="90" style={{marginBottom: '40px', marginTop: '40px'}} /> {/**#610A74 */}
            <Card.Title style={{marginBottom: '10px', fontSize: '24px', fontWeight:'700'}}>Ach Gadol</Card.Title>
            <img src={line} alt="Icon 1" width="30" height="50" style={{marginBottom: '20px'}} /> {/**#610A74 */}
            <Card.Text style={{fontSize: '16px', fontWeight: '600', color: '#4c4f4e', marginRight: '4rem', marginLeft: '4rem', textAlign: 'center', marginBottom: '50px'}}>
                Tsahal Connection est relié à l'association Ach Gadol qui affecte un mentor à chaque soldat seul pendant son service. Chaque année, plus de 150 soldats seuls francophones bénéficient de ce soutien pendant leurs services.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ThreeCards;
